import React, {useEffect, useState} from "react";
import * as prosConnect from "../prodect/ProsConnect";
import {relativeTimeFilterRange, timeFilterToString} from "../containers/ProjectReportTable";
import {ATTR_CREATED_MS_I, ATTR_UPDATED_MS_I, TAG_CH_PREFIX, TAG_RB_PREFIX} from "../prodect/ProsConnect";


/**
 * Show summary about table filter - namely number of selected reports and column filters
 * rendering link settings :
 *      link.selected_reports that is an array of report ID's - to show number of reports
 *      link.ui_settings.filters that is an array of column id and values
 */

const TIME_COLUMNS = ["ui_expires", "ui_lastUpdatedMs", "created_ms"]
const RELATIVE_TIME_COLUMNS = ["ui_timeToDate"]

export const COLUMN_NAME_MAPPING = {
    "ui_report":        "Raportti",
    "ui_title":         "Otsikko",
    "ui_text":          "Teksti",
    "ui_expires":       "Määräaika",
    "ui_timeToDate":    "Aikaa jäljellä",
    "created_by":       "Tekijä",
    "created_ms":       "Luotu",
    "ui_lastUpdatedBy": "Muokannut",
    "ui_lastUpdatedMs": "Muokattu",
    "ui_mandatoryMissing": "Puutteita",
}

export function getColumnName(columnId) {
    // Calculated or fixed table column..
    if (COLUMN_NAME_MAPPING.hasOwnProperty(columnId)) {
        return COLUMN_NAME_MAPPING[columnId]
    }
    let project = prosConnect.getActiveProject()
    if (project) {
        // Multi select / tag<x>
        let tagInd = project.getRbTags().findIndex(tag => tag === columnId)
        if (tagInd >= 0) {
            return project.getRbTagTitles()[tagInd]
        }
        // yes / no tag_ch<x>
        tagInd = project.getChTags().findIndex(tag => tag === columnId)
        if (tagInd >= 0) {
            return project.getChTagLabels()[tagInd]
        }
        // Text field / txt<x>
        tagInd = project.getTxtTags().findIndex(tag => tag === columnId)
        if (tagInd >= 0) {
            return project.getTxtLabels()[tagInd]
        }
    }
    // Fallback showing column id
    return columnId
}


export default function LinkFilters (props) {
    const {linkId} = props
    const [link, setLink] = useState()

    let project = prosConnect.getActiveProject()

    useEffect(() => {
        // Called once when edit notif settings UI component created
        loadLink()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    /**
     * Fetches link created using table
     */
    async function loadLink() {
        let link = await prosConnect.awaitGetNotificationRuleLink(linkId)
        setLink(link)
    }

    /**
     * Visualize link filter - example of filters
     *  ui_settings.filters:
     *          {id: "ui_text", value: "Kaakeli"}
     *          {id: "ui_expires", value: [1676937600000, null]}
     *          {id: "ui_timeToDate", value: ["week", "-5", 1]}
     *          {id: "tag2", value: ["Uusi", "Käynnissä", "Valmis"]}
     *          {id: "tag_ch1", value: "include"}
     *          {id: "created_by", value: "lasse"}
     *          {id: "created_ms", value: [null, 1675209600000]}
     *          {id: "ui_lastUpdatedMs", value: [1675209600000, 1677542400000]}
     *          {id: "ui_lastUpdatedBy", value: "Lasse,Jere"}
     * @param filter
     */
    function renderFilter(filter) {
        let name = getColumnName(filter.id)
        let value
        if (TIME_COLUMNS.includes(filter.id)) {
            // time range
            let fromDate = timeFilterToString(filter.value[0]) || 'Ei asetettu'
            let toDate = timeFilterToString(filter.value[1]) || 'Ei asetettu'
            value = fromDate + " - " + toDate
        } else if(RELATIVE_TIME_COLUMNS.includes(filter.id)) {
            // relative time range
            let range = relativeTimeFilterRange(filter.value)
            value = range.timeRangeStr
        } else if (filter.id.indexOf(TAG_CH_PREFIX) >= 0) {
            // yes / no
            value = filter.value === 'include' ? "Y" : "n"
        } else if (filter.id.indexOf(TAG_RB_PREFIX) >= 0) {
            // multiselect
            value = filter.value.join(", ")
        } else if (filter.id === 'ui_mandatoryMissing') {
            value = 'Min: ' + filter.value.join(", Max: ")
        } else {
            // text filter
            value = filter.value
        }
        return <div key={filter.id}><h6>{name}</h6><p>{value}</p></div>
    }

    function renderReportsSelected() {
        let reportsSelectedInLink = Array.isArray(link.selected_reports) ? link.selected_reports.length : '?'
        let reportsAfterLinkUpdated = project
            .getReports(true)
            .filter(report => report[ATTR_CREATED_MS_I] > link[ATTR_UPDATED_MS_I])
            .length
        let reportsIncluded = reportsSelectedInLink + reportsAfterLinkUpdated
        let totalReportsCount = project.getReports(true).length
        return <p>
            {"Raportteja valittu " +  reportsIncluded + "/" + totalReportsCount}
        </p>
    }

    if (!project) {
        return <p>Ei projektia?</p>
    }

    if (!link || !link.ui_settings || !link.ui_settings.filters) {
        return <p><i>Lisäehtoja ei ole asetettu.</i></p>
    }

    return <div className={"msg msg-info margin-bottom"}>
        {renderReportsSelected()}
        <div className={"grid-container grid-1" + (link.ui_settings.filters.length > 1 ? " grid-2_lg" : "")}>
            {link.ui_settings.filters.map(filter => renderFilter(filter))}
        </div>
    </div>
}

